
























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxButton, DxTextBox, DxLookup, DxList, DxSelectBox } from 'devextreme-vue';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import { DxValidator, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';   
import { ClientService } from '@/service/ClientService';
import { InvoiceLineItemService } from '@/service/InvoiceLineItemService';
import { SelectOption } from '@/models/SelectOption';
import { Prop } from 'vue-property-decorator';
import { confirm } from 'devextreme/ui/dialog';           
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";
import _ from 'lodash';
import { InvoiceLineItemUpdateCountryDto } from '@/models/InvoiceLineItemUpdateCountryDto';
import * as overlay from 'devextreme/ui/overlay';
import { MatterDto } from '@/models/matter/MatterDto';
import { InvoiceLineItemUpdateMatterNameDto } from '@/models/InvoiceLineItemUpdateMatterNameDto';
import DataSource from 'devextreme/data/data_source';

@Component({
    components: {
        DxButton,            
        Popup,            
        DxTextBox,            
        DxToolbarItem,
        DxLookup,     
        DxList,      
        DxSelectBox,
        DxValidator,
        DxCustomRule,
        DxScrollView,            
        DxValidationGroup,
        DxRequiredRule,
        DxLoadIndicator
    }
})
export default class UpdateLineItemsMatterName extends Vue {
    public $refs: Vue['$refs'] & {
        validationGroupRef? : ValidationGroup;
        popup?: Popup;
        matterNameSelectBox?: DxSelectBox;
    } = {};
    
    @Prop({ default: false })
    showDialog!: boolean;        

    @Prop()
    clientId!: Guid;

    @Prop()
    selectedRows!: ManualCodeInvoiceLineItemDto[];

    @Prop()
    currentMatter!: MatterDto;

    matters: MatterDto[] = [];

    get mattersDataSource() {
        return this.matters;
    }

    matterNamesDataSource: DataSource = new DataSource({});        

    updatingMatterName: boolean = false;  
    selectedMatter: any = null;
    selectedRowsCount: number = 0;
    selectedRowsIds: Array<Guid> = [];            
    lineItemService: InvoiceLineItemService;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {
        this.$emit("hiding", this.selectedRowsIds, this.selectedMatter);
    }

    @Watch("showDialog")
    onPropertyChanged(value: boolean, oldValue: boolean) {                
        if (value) {                                                         
            this.selectedRowsCount = this.selectedRows.length;
            this.validationGroup.reset();
            this.loadData();
        }            
    }   

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }
   
    constructor() {
        super();         
        this.lineItemService = new InvoiceLineItemService();
        overlay.baseZIndex(2000); 
        this.loadData();       
        
    }        

    async loadData() { 
        let clientService = new ClientService();
        this.matters = await clientService.getMatters(this.clientId);
        this.matterNamesDataSource = new DataSource({
            key: ['MatterName', 'CountryId'],
            store: {
            type: 'array',
            data: this.mattersDataSource
        },
        paginate: true,
        pageSize: 10
        });        
    }

    hidingUpdate() {
        this.showingDialog = false;         
    }

    createCustomMatter(e: any) {            
        if(!this.matters.some(m => m == e.text)) {                
            let matter: MatterDto = {
                MatterId: '',
                ClientId: this.clientId,
                CountryId: this.currentMatter.CountryId,
                CountryCode: this.currentMatter.CountryCode,
                MatterName: e.text,
                FilingTypeId: 1
            };
            e.customItem = matter;
            this.matters.push(matter);
            this.selectedMatter = matter;
        }     
    }

    getMatterDisplay(item: any) {
        let result = '';
        if (item && item.MatterName) {
            result = `${item.MatterName}, CountryCode: ${item.CountryCode}`;
        }            

        return result;
    }

    async confirmSave() {   
        if (this.updatingMatterName) {
            return;
        }

        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }        
        
        let oldMatter = this.matters.filter(m => m.MatterId == this.currentMatter.MatterId)[0];                                   
        if (this.currentMatter.MatterId == this.selectedMatter.MatterId) {
            this.hidingUpdate();
            return;
        }

        let dialogText: string = `Are you sure you want to update the matter name from ${oldMatter.MatterName} 
            to ${this.selectedMatter.MatterName} for the ${this.selectedRowsCount} selected row(s)?`

        var dialogResult = confirm(dialogText, "Update Matter Name");
        dialogResult
        .then(dialogResult => {
            if(dialogResult) {                    
                this.selectedRowsIds = this.selectedRows.map(li => li.InvoiceLineItemId);
                let updateDto: InvoiceLineItemUpdateMatterNameDto = {
                    InvoiceLineItemIds: this.selectedRowsIds,
                    MatterName: this.selectedMatter.MatterName,
                    CountryId: this.selectedMatter.CountryId
                };

                this.updatingMatterName = true;
                this.lineItemService.updateLineItemMatterName(updateDto)
                .then(_ => {       
                    this.hidingUpdate();                                                
                })
                .finally( () => {
                    this.updatingMatterName = false;
                });                              
            }                
        });                     
    }
}
